import React, {
  forwardRef,
  RefObject,
  useEffect,
  useImperativeHandle,
  useLayoutEffect,
  useState,
} from 'react'
import { Button, Modal } from 'react-bootstrap'
import { IModalReference } from 'shared/models/References'
import { vestigingen, VestigingEnum } from '../../models/Enum'
import { ILocatieGlnModel } from '../../models/ILocatieGlnModel'
import GlnService from '../../service/GlnService'
import SelectieButtonEnum from '../SelectieButtonEnum'
import { CustomerModel } from 'shared/models/CutomerDeliveryLocations/CustomerModel'

interface IShipToAddressSearchProps {
  onLinkedAddress: (address: ILocatieGlnModel) => void
  onHide?: () => void
  onShow?: () => void
  showModal?: boolean
  warehouse: VestigingEnum
  customer: CustomerModel
}

function ShipToAddressSearch(props: IShipToAddressSearchProps, ref: RefObject<IModalReference>) {
  const [koppelLocaties, setKoppelLocaties] = useState<ILocatieGlnModel[]>()
  const [address, setAddress] = useState('')
  const [errorMessage, setErrorMessage] = useState<string>()
  const [showModal, setShowModal] = useState(false)
  const [location, setLocation] = useState(0)
  const [customer, setCustomer] = useState<CustomerModel>()

  useEffect(() => {
    setCustomer(props.customer)
    setLocation(props.warehouse)
  }, [])

  useLayoutEffect(() => {
    if (props.showModal != null && props.showModal !== showModal) {
      if (props.showModal) {
        show()
      } else {
        hide()
      }
    }
  }, [props.showModal])

  useImperativeHandle(ref, () => ({
    show: () => {
      show()
    },
    hide: () => {
      hide()
    },
  }))

  const show = () => {
    setErrorMessage(null)
    setLocation(props.warehouse)

    if (!showModal) {
      setShowModal(true)
      if (!!props.onShow) {
        props.onShow()
      }
    }
  }

  const hide = () => {
    if (showModal) {
      setShowModal(false)
      if (!!props.onHide) {
        props.onHide()
      }
    }
  }

  const linkedAddress = (linked: ILocatieGlnModel) => {
    props.onLinkedAddress(linked)
    hide()
  }

  const renderLocatieRows = (data: ILocatieGlnModel[]) => {
    return data.map(x => {
      return (
        <tr key={x.locatieGlnId}>
          <td className='pl-4'>{x.locatieGlnCode}</td>
          <td>{x.locatieGlnNaam}</td>
          <td>{x.locatieGlnOmschrijving}</td>
          <td>{getWarehouse(x.vestigingCode)}</td>
          <td>
            <Button variant='primary' onClick={() => linkedAddress(x)}>
              Koppel
            </Button>
          </td>
        </tr>
      )
    })
  }

  const getWarehouse = (code: number): string => {
    return VestigingEnum[code]
  }

  const searchAddressesIfEnter = (e: string) => {
    if (e === 'Enter') {
      searchAddresses()
    }
  }

  const searchAddresses = async () => {
    if (!!address && address.length > 0 && location > 0) {
      const result = await GlnService.getKoppelLocaties(address, location)
      if (result.success) {
        setErrorMessage(null)
        setKoppelLocaties(result.payLoad)
      } else {
        setErrorMessage(result.errorMessage)
        setKoppelLocaties(null)
      }
    }
  }

  const setAddressField = (e: string) => {
    setAddress(e)
    setKoppelLocaties(null)
  }

  const setLocationField = (e: string) => {
    var tempLocationId: number = Number.parseInt(e)
    setLocation(tempLocationId)
    setKoppelLocaties(null)
  }

  return (
    <Modal
      show={showModal}
      onHide={hide}
      animation={false}
      className='modal-stack2 p-2'
      dialogClassName='new-modal'
      size='xl'
    >
      <Modal.Header closeButton>
        <Modal.Title>Ship-to - Locatie zoeken</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorMessage != null && (
          <div className='alert alert-danger'>{errorMessage}</div>
        )}

        <table className='selectie mt-n2'>
          <thead>
            <tr>
              <th className='selectie-label w-25'>Klant:</th>
              <th className='selectie-label'></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong className='pl-4'>CKN:</strong>
                <p className='d-inline pl-2'>{customer?.customerNumber}</p>
              </td>
              <td>
                <strong>Naam:</strong>
                <p className='d-inline pl-2'>{customer?.customerName}</p>
              </td>
            </tr>
            <tr>
              <td>
                <strong className='pl-4'>GLN:</strong>
                <p className='d-inline pl-2'>{customer?.customerEanCode}</p>
              </td>
            </tr>
          </tbody>
        </table>

        <table className='selectie mt-n5'>
          <thead>
            <tr>
              <th className='selectie-label w-25'>Locaties:</th>
              <th className='selectie-label'></th>
              <th className='selectie-label'></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className='pl-4'>
                  <SelectieButtonEnum
                    type={VestigingEnum}
                    options={vestigingen}
                    selected={location}
                    onChange={e => setLocationField(e.target.value)}
                  />
                </div>
              </td>
              <td>
                <input
                  value={address}
                  placeholder='Geef locatie naam in...'
                  onChange={e => setAddressField(e.target.value)}
                  onKeyUp={e => searchAddressesIfEnter(e.key)}
                />
              </td>
              <td>
                <div className='row no-gutters'>
                  <div className='col'></div>
                  <div className='col-auto'>
                    <button
                      className='btn btn-primary'
                      disabled={
                        !address || address.length === 0 || location == 0
                      }
                      onClick={() => searchAddresses()}
                    >
                      Zoeken
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        {!!koppelLocaties && (
          <React.Fragment>
            <table className='selectie mt-n5'>
              <div className='modal-scrolldiv-60'>
              <thead>
                <tr>
                    <th className='selectie-label w-25'>Resultaten:</th>
                    <th className='w-25'></th>
                    <th className='w-25'></th>
                    <th className='w-25'></th>
                    <th className='w-10'></th>
                </tr>
              </thead>
              <tbody>
                  <tr>
                    <th className='pl-4'>Locatie Gln</th>
                    <th>Locatie Naam</th>
                    <th>Omschrijving</th>
                    <th>Vestiging</th>
                    <th></th>
                  </tr>
                  {renderLocatieRows(koppelLocaties)}
              </tbody>
              </div>
            </table>
          </React.Fragment>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={hide}>
          Sluiten
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
export default forwardRef(ShipToAddressSearch)
